import {
  AssetMessageFinalOutput,
  GamgeeChatMessageRead,
} from "~/types/message";
import { useGlobalStore } from "~/stores/store-provider";
import MarkdownContainer from "~/components/markdown-container/markdown-container";
import AssetItem from "./asset-item";

interface FinalOutputProps {
  finalOutput: AssetMessageFinalOutput;
  message: GamgeeChatMessageRead;
}

const FinalOutput = ({ finalOutput, message }: FinalOutputProps) => {
  const { output, assets, follow_up_questions } = finalOutput;
  const { messageInputDraft, setMessageInputDraft } = useGlobalStore(
    (state: any) => state
  );
  const handleFollowUpQuestionClick = (question: string) => {
    if (messageInputDraft.trim() === "") {
      setMessageInputDraft(question);
    }
  };

  return (
    <div>
      {output && (
        <div className="rounded-lg mb-4">
          <MarkdownContainer message={message}>{output}</MarkdownContainer>
        </div>
      )}

      {assets && assets.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xl font-semibold mb-2">Assets</h2>
          <div className="flex flex-col gap-2">
            {assets.map((asset, index) => (
              <AssetItem
                key={index}
                title={asset.title}
                description={asset.description}
                filename={asset.filename}
                sessionId={message.session_id}
              />
            ))}
          </div>
        </div>
      )}

      {follow_up_questions && follow_up_questions.length > 0 && (
        <div className="rounded-lg p-5 ">
          <h2 className="text-base font-semibold flex items-center gap-2 mb-3">
            Follow-up Questions
          </h2>
          <ul className="list-none p-0 m-0 flex flex-col gap-2">
            {follow_up_questions.map((question, index) => (
              <li key={index}>
                <button
                  className="btn btn-outline btn-block justify-start"
                  onClick={() => handleFollowUpQuestionClick(question)}
                >
                  {question}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FinalOutput;
